export default __webpack_public_path__ + "static/media/wide_button.fb55424d.png";